(function () {
  'use strict';

  var SELECTOR = '[data-nucery-header-hero]';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function HeaderHero(root) {
    this.root = root;
    this.track = root.querySelector('[data-nucery-hero-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-nucery-hero-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-nucery-hero-dot]'));
    this.prevBtn = root.querySelector('[data-nucery-hero-prev]');
    this.nextBtn = root.querySelector('[data-nucery-hero-next]');
    this.pauseBtn = root.querySelector('[data-nucery-hero-pause]');
    this.index = 0;
    this.timer = null;
    this.progressRaf = null;
    this.progressStart = 0;
    this.paused = root.dataset.autoplay !== 'true' || prefersReducedMotion();
    this.duration = parseInt(root.dataset.autoplayMs, 10) || 6000;
    this.reduced = prefersReducedMotion();
    this.touchStartX = 0;
    this.touchDeltaX = 0;

    if (this.reduced) {
      this.root.classList.add('is-reduced-motion');
      this.paused = true;
    }

    this.bind();
    this.goTo(0, true);
    if (!this.paused && this.slides.length > 1) {
      this.startAutoplay();
    }
    this.observeVisibility();
    this.bindVideoResize();
  }

  HeaderHero.prototype.bindVideoResize = function () {
    var self = this;
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        self.syncVideos();
      }, 150);
    });
  };

  HeaderHero.prototype.bind = function () {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.goTo(self.index - 1);
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.goTo(self.index + 1);
      });
    }
    if (this.pauseBtn) {
      this.pauseBtn.addEventListener('click', function () {
        self.togglePause();
      });
    }

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        self.goTo(i);
      });
    });

    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.goTo(self.index - 1);
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.goTo(self.index + 1);
      }
    });

    var passive = { passive: true };
    this.track.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || !e.touches.length) return;
        self.touchStartX = e.touches[0].clientX;
        self.touchDeltaX = 0;
      },
      passive
    );
    this.track.addEventListener(
      'touchmove',
      function (e) {
        if (!e.touches || !e.touches.length) return;
        self.touchDeltaX = e.touches[0].clientX - self.touchStartX;
      },
      passive
    );
    this.track.addEventListener('touchend', function () {
      if (Math.abs(self.touchDeltaX) < 48) return;
      if (self.touchDeltaX < 0) self.goTo(self.index + 1);
      else self.goTo(self.index - 1);
    });
  };

  HeaderHero.prototype.observeVisibility = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) return;

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            self.syncVideos();
            if (!self.paused && self.slides.length > 1) self.startAutoplay();
          } else {
            self.stopAutoplay();
            self.pauseAllVideos();
          }
        });
      },
      { threshold: 0.15 }
    ).observe(this.root);
  };

  HeaderHero.prototype.wrapIndex = function (i) {
    var n = this.slides.length;
    if (n < 1) return 0;
    return ((i % n) + n) % n;
  };

  HeaderHero.prototype.goTo = function (i, instant) {
    var next = this.wrapIndex(i);
    this.index = next;
    this.track.style.transform = 'translate3d(-' + next * 100 + '%, 0, 0)';

    this.slides.forEach(function (slide, idx) {
      var active = idx === next;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      slide.classList.toggle('is-active', active);
    });

    this.dots.forEach(function (dot, idx) {
      var active = idx === next;
      dot.setAttribute('aria-current', active ? 'true' : 'false');
      dot.classList.toggle('is-active', active);
    });

    this.syncVideos();
    this.resetProgress(instant);

    if (!this.paused && this.slides.length > 1) {
      this.startAutoplay();
    }
  };

  HeaderHero.prototype.isMobileViewport = function () {
    return window.matchMedia('(max-width: 749px)').matches;
  };

  HeaderHero.prototype.getSlideVideo = function (slide) {
    if (this.isMobileViewport()) {
      return (
        slide.querySelector('.nucery-header-hero__video--mobile') ||
        slide.querySelector('.nucery-header-hero__video')
      );
    }
    return (
      slide.querySelector('.nucery-header-hero__video--desktop') ||
      slide.querySelector('.nucery-header-hero__video')
    );
  };

  HeaderHero.prototype.syncVideos = function () {
    this.slides.forEach(
      function (slide, idx) {
        var videos = slide.querySelectorAll('video');
        if (!videos.length) return;

        videos.forEach(function (video) {
          video.pause();
          if (idx !== this.index) {
            try {
              video.currentTime = 0;
            } catch (e) {}
          }
        }, this);

        if (idx === this.index && !this.paused) {
          var activeVideo = this.getSlideVideo(slide);
          if (!activeVideo) return;
          var playPromise = activeVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        }
      }.bind(this)
    );
  };

  HeaderHero.prototype.pauseAllVideos = function () {
    this.slides.forEach(function (slide) {
      slide.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });
    });
  };

  HeaderHero.prototype.startAutoplay = function () {
    this.stopAutoplay();
    if (this.paused || this.slides.length < 2) return;
    var self = this;
    this.progressStart = performance.now();
    this.animateProgress();

    this.timer = window.setTimeout(function () {
      self.goTo(self.index + 1);
    }, this.duration);
  };

  HeaderHero.prototype.stopAutoplay = function () {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
    if (this.progressRaf) {
      window.cancelAnimationFrame(this.progressRaf);
      this.progressRaf = null;
    }
  };

  HeaderHero.prototype.resetProgress = function (instant) {
    this.root.style.setProperty('--nhh-progress', instant ? '100' : '0');
  };

  HeaderHero.prototype.animateProgress = function () {
    var self = this;
    function tick(now) {
      if (self.paused) return;
      var elapsed = now - self.progressStart;
      var pct = Math.min(100, (elapsed / self.duration) * 100);
      self.root.style.setProperty('--nhh-progress', String(pct));
      if (pct < 100) {
        self.progressRaf = window.requestAnimationFrame(tick);
      }
    }
    this.progressRaf = window.requestAnimationFrame(tick);
  };

  HeaderHero.prototype.togglePause = function () {
    this.paused = !this.paused;
    this.root.classList.toggle('is-paused', this.paused);

    if (this.pauseBtn) {
      var label = this.paused
        ? this.pauseBtn.getAttribute('data-label-play') || 'Play'
        : this.pauseBtn.getAttribute('data-label-pause') || 'Pause';
      this.pauseBtn.setAttribute('aria-label', label);
      this.pauseBtn.setAttribute('aria-pressed', this.paused ? 'true' : 'false');
    }

    if (this.paused) {
      this.stopAutoplay();
      this.pauseAllVideos();
    } else {
      this.syncVideos();
      this.startAutoplay();
    }
  };

  function initOverlayHeader(hero) {
    if (!hero.classList.contains('nucery-header-hero--overlay-nav')) {
      return;
    }

    var html = document.documentElement;
    html.classList.add('nucery-hero-overlay-active');

    var headerWrap = document.getElementById('HeaderWrapper');

    function layoutMobileCircleStrip() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var group = document.querySelector('.shopify-section-group-header-group');
      var mcsSection = group && group.querySelector('.section-mobile-circle-slider');

      html.classList.toggle(
        'nucery-mobile-circle-on-hero',
        !!(mobile && mcsSection && hero.classList.contains('nucery-header-hero--overlay-nav'))
      );

      if (!html.classList.contains('nucery-mobile-circle-on-hero') || !group || !mcsSection) {
        if (group) {
          group.style.removeProperty('--nucery-vsa-height');
          group.style.removeProperty('--nucery-mobile-strip-top');
          group.style.removeProperty('--nucery-mobile-strip-height');
        }
        return;
      }

      var vsaEl = group.querySelector('.vsa');
      var vsaSection = vsaEl ? vsaEl.closest('.shopify-section') || vsaEl : null;
      var vsaH = vsaSection ? vsaSection.offsetHeight : 0;
      var headerH = headerWrap ? headerWrap.offsetHeight : 0;
      var stripH = mcsSection.offsetHeight;

      group.style.setProperty('--nucery-vsa-height', vsaH + 'px');
      group.style.setProperty('--nucery-mobile-strip-top', vsaH + headerH + 'px');
      group.style.setProperty('--nucery-mobile-strip-height', stripH + 'px');
    }

    function measure() {
      var barH = headerWrap ? headerWrap.offsetHeight : 60;
      hero.style.setProperty('--nhh-header-offset', barH + 'px');
      layoutMobileCircleStrip();
    }

    measure();
    window.addEventListener('resize', measure);

    if (headerWrap && 'ResizeObserver' in window) {
      new ResizeObserver(measure).observe(headerWrap);
    }

    var mcsSection = document.querySelector(
      '.shopify-section-group-header-group .section-mobile-circle-slider'
    );
    if (mcsSection && 'ResizeObserver' in window) {
      new ResizeObserver(measure).observe(mcsSection);
    }

    var vsaSection = document.querySelector('.shopify-section-group-header-group .vsa');
    if (vsaSection && 'ResizeObserver' in window) {
      var vsaRoot = vsaSection.closest('.shopify-section') || vsaSection;
      new ResizeObserver(measure).observe(vsaRoot);
    }
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.__nuceryHeroInit) return;
      el.__nuceryHeroInit = true;
      new HeaderHero(el);
      initOverlayHeader(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector(SELECTOR);
    if (el && !el.__nuceryHeroInit) {
      el.__nuceryHeroInit = true;
      new HeaderHero(el);
      initOverlayHeader(el);
    }
  });
})();
